import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import QDialog from 'quasar/src/components/dialog/QDialog.js';

@Component
export default class DialogMixin extends Vue {
  $refs!: {
    dialog: QDialog
  }

  get target() {
    return this.$refs.dialog
  }

  show() {
    this.target.show()
  }

  // following method is REQUIRED
  // (don't change its name --> "hide")
  hide() {
    this.target.hide()
  }

  onDialogHide() {
    // required to be emitted
    // when QDialog emits "hide" event
    this.$emit('hide')
  }

  onOKClick() {
    // on OK, it is REQUIRED to
    // emit "ok" event (with optional payload)
    // before hiding the QDialog
    this.$emit('ok')
    // or with payload: this.$emit('ok', { ... })

    // then hiding dialog
    this.hide()
  }

  onCancelClick() {
    // we just need to hide dialog
    this.hide()
  }
}
